import React from 'react';

import { Progress } from '../../element/Progress/Progress';
import { Tooltip } from '../../element/Tooltip/Tooltip';

import type { FocusAreaBarsFocusAreaType } from './focus-area-bars.types';
import { FocusAreaBarsExperience } from './FocusAreaBarsExperience';

export type FocusAreaBarsProgressProps = {
  name?: string;
  focusArea: FocusAreaBarsFocusAreaType;
};

export const FocusAreaBarsProgress = ({
  name = 'FOCUS_AREA_BARS_PROGRESS',
  focusArea,
}: FocusAreaBarsProgressProps) => {
  const currentStep =
    focusArea.yearsOfExperience <= 1
      ? 1
      : Math.round(focusArea.yearsOfExperience);

  return (
    <Tooltip
      name={name}
      position="bottom"
      anchor={
        <div data-test={`${name}_ANCHOR`}>
          <Progress
            name={`${name}_BAR`}
            color="sky"
            backgroundColor="transparent"
            currentStep={currentStep}
            totalSteps={10}
            size="large"
            showHover
            hideLabel
          />
        </div>
      }
    >
      <FocusAreaBarsExperience experiences={focusArea.experiences} />
    </Tooltip>
  );
};
